import ListingActions from 'client/actions/Listing';
import log from 'client/lib/log';

const debug = log.debug('sunroom:Search');

export default async function removeSuggestedFilter({ state }) {
  const previousSearchFilters = state.get(['currentUser', 'previousSearchFilters']);
  const currentViewedListings = state.get(['listingsMapView', 'viewedListings']);
  const currentTotalListingsCount = state.get(['listings', 'totalListingsCount']);

  state.set(['currentUser', 'searchFilters'], previousSearchFilters);
  state.set(['search', 'filters'], previousSearchFilters);
  state.set(['search', 'selectedSuggestedSearchFilter'], null);

  debug('Appling filters', previousSearchFilters);
  await ListingActions.reset({ state });

  state.set(['listingsMapView', 'mapChanged'], false);
  state.set(['listingsMapView', 'showResultsMatched'], true);
  state.set(['listingsMapView', 'viewedListings'], currentViewedListings);
  state.set(['listings', 'totalListingsCount'], currentTotalListingsCount);
  state.commit();
}
